import React from 'react';
import { CustomTooltip } from '@components/CustomTooltip';
import SelectorButton from '@components/selectors/core/SelectorButton';
import { Modes } from '@constants/canvas/layers';
import { useProject } from '@context/Project';
import useProjectId from '@hooks/useProjectId';
import useToggle from '@hooks/useToggle';
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetProjectDomainsQuery } from '@store/services/projects';
import { themePalette } from '@theme/muiTheme';
import { GlobalIcon } from '@utils/iconsDefs';
import { Tabs } from '@views/Insights/types';
import ScopeFilterModal from '@views/Project/components/ScopeFilterModal/ScopeFilterModal';
import useDomainsFilter from '@views/Project/hooks/useDomainsFilter';

const ScopeFilter = () => {
  const id = useProjectId();

  const {
    toolbox: { mode },
    insightsTab,
    isInsightsMode,
    isVersionsShown,
    isDashboardMode,
  } = useProject();

  const [isScopeOpen, scopeControls] = useToggle();

  const { data: domains = [] } = useGetProjectDomainsQuery(id ?? skipToken);
  const { ScopeName, ScopeCount } = useDomainsFilter(domains);

  const isScopeFilterDisabled =
    (insightsTab !== Tabs.Default && isInsightsMode) ||
    isVersionsShown ||
    isDashboardMode ||
    mode === Modes.RiskManagement;

  return (
    <>
      <ScopeFilterModal
        open={isScopeOpen}
        onClose={scopeControls.off}
        domains={domains}
      />

      <CustomTooltip
        icon={<GlobalIcon />}
        title="Scope"
        subtitle="Explore your model from various perspectives using scope filtering."
        placement="bottom-start"
        enterDelay={900}
        enterNextDelay={900}
      >
        <div>
          <SelectorButton
            title={ScopeName}
            disabled={isScopeFilterDisabled}
            sx={{
              width: 240,
              border: `1px solid ${
                themePalette.grey[isScopeFilterDisabled ? 500 : 700]
              }`,
            }}
            onClick={scopeControls.on}
            count={ScopeCount}
          />
        </div>
      </CustomTooltip>
    </>
  );
};

export default ScopeFilter;
